import EditContact from './EditContact';

export default EditContact;
